module.exports = require('../../dist/mappings/wp/article');
